export type DocumentExtractionInfoCardType =
  "profile_found" | "profile_found_with_conflicts" | "create_profile";

interface DocumentExtractionInfoCardConfig {
  cardTitle: string | ((params: { differenceCount?: number }) => string);
  cardContent: string;
  buttonContent?: string | ((params: { differenceCount?: number }) => string);
}

export const DOCUMENT_EXTRACTION_INFO_CARD_CONFIG: Record<
  DocumentExtractionInfoCardType,
  DocumentExtractionInfoCardConfig
> = {
  profile_found: {
    cardTitle: "We found a related profile",
    cardContent:
      "Profile matching the data extracted from the document was auto-selected for you.",
  },
  profile_found_with_conflicts: {
    cardTitle: ({ differenceCount = 0 }) =>
      `Related profile found with ${differenceCount} conflict${differenceCount !== 1 ? "s" : ""}`,
    cardContent:
      "This profile had some matching data with the selected document, but we identified conflicts.",
    buttonContent: ({ differenceCount = 0 }) =>
      `Resolve ${differenceCount} conflict${differenceCount !== 1 ? "s" : ""}`,
  },
  create_profile: {
    cardTitle: "No matching profile found",
    cardContent: "There is no profile matching the data extracted from the document.",
    buttonContent: "Create profile with extracted data",
  },
};
